













import { Component } from 'vue-property-decorator';
import ClockIcon from '@/components/Helper/Icon/Svg/ClockIcon.vue';
import CurrentTimeMixin from '@/mixin/current-time.mixin';

@Component({
  components: { ClockIcon },
})
export default class CurrentDateTime extends CurrentTimeMixin {}
